import { FunctionComponent, useState } from 'react'
import SupportDialog from '../Dialog/supportDialog'
import { useAuth } from '@/modules/context/AuthContext'
import Desktop from '@/modules/desktopMobile/desktop'
import Mobile from '@/modules/desktopMobile/mobile'
import TrusteeHomeDesktop from './TrusteeHomeDesktop'
import TrusteeHomeMobile from './TrusteeHomeMobile'
import ResetPasswordDialog from '../Dialog/resetPassword'
import ChangeLanguageDialog from '../Dialog/changeLanguage'

interface TrusteeHomeProps {
    backendVersion: string
    frontendVersion: string
}

const TrusteeHome: FunctionComponent<TrusteeHomeProps> = ({ backendVersion, frontendVersion }: TrusteeHomeProps) => {
    const { user } = useAuth()

    const [isDialogForgottenPasswordOpen, setDialogForgottenPasswordOpen] = useState<boolean>(false)
    const [isDialogChangeLanguageOpen, setDialogChangeLanguageOpen] = useState<boolean>(false)

    const [isDialogSupportOpen, setDialogSupportOpen] = useState<boolean>(false)

    return (
        <>
            <Desktop>
                <TrusteeHomeDesktop
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogChangeLanguageOpen={setDialogChangeLanguageOpen}
                    setDialogForgottenPasswordOpen={setDialogForgottenPasswordOpen}
                    setDialogSupportOpen={setDialogSupportOpen}
                />
            </Desktop>
            <Mobile>
                <TrusteeHomeMobile
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogChangeLanguageOpen={setDialogChangeLanguageOpen}
                    setDialogForgottenPasswordOpen={setDialogForgottenPasswordOpen}
                    setDialogSupportOpen={setDialogSupportOpen}
                />
            </Mobile>
            {user && (
                <>
                    <ResetPasswordDialog
                        email={user.email}
                        open={isDialogForgottenPasswordOpen}
                        handleClose={(): void => setDialogForgottenPasswordOpen(false)}
                    />
                    <ChangeLanguageDialog
                        open={isDialogChangeLanguageOpen}
                        handleClose={(): void => setDialogChangeLanguageOpen(false)}
                    />
                    <SupportDialog
                        open={isDialogSupportOpen}
                        handleClose={(): void => setDialogSupportOpen(false)}
                        email={user.email}
                    />
                </>
            )}
        </>
    )
}

export default TrusteeHome
